const ServiceNowIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 18 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0C3.96 0 0 3.96 0 9C0 11.64 1.08 14.04 2.76 15.72C3.36 16.32 4.44 16.32 5.16 15.84C6.12 15 7.56 14.52 9 14.52C10.56 14.52 11.76 15 12.84 15.84C13.56 16.44 14.52 16.32 15.24 15.6C16.92 13.92 18 11.64 18 9C17.88 4.08 13.92 0 9 0ZM8.88 13.68C6.12 13.68 4.32001 11.64 4.32001 9.12C4.32001 6.6 6.12 4.56 8.88 4.56C11.64 4.56 13.44 6.6 13.44 9.12C13.44 11.64 11.64 13.68 8.88 13.68Z'
        fill='#81B5A1'
      />
    </svg>
  )
}

export default ServiceNowIcon
